import { NavLink } from 'react-router-dom'
import { MAIN_NAV } from '@/shared/constants/navigation'

/**
 * `DefaultLayout` 을 쓰지 않는 화면의 헤더. 실측(2026-09-07) 결과 지금 이것이 보이는 곳은
 * **`/about` 하나**다 — 나머지 화면은 `mobile-screen` · `pc-scale` 이 붙어 CSS 가 숨긴다.
 * 메뉴 항목은 `MAIN_NAV` 하나에서 온다(헤더·사이드바와 같은 정본).
 */
export function SiteHeader() {
  return (
    <header className="site-header sticky top-0 z-50 flex h-[60px] items-center gap-6 border-b border-white-300 bg-white-50/90 px-6 backdrop-blur-[8px] [body:has(.mobile-screen)_&]:hidden md:[body:has(.pc-scale)_&]:hidden md:[body:has(.mobile-screen):not(:has(.tablet-screen)):not(:has(.pc-scale))_&]:flex">
      <NavLink to="/" className="text-[17px] font-bold tracking-[-0.02em]">
        해봄
        <small className="block text-[11px] font-medium tracking-normal text-white-900">
          광명 문제해결 연결 플랫폼
        </small>
      </NavLink>
      <nav className="ml-auto flex flex-wrap gap-1" aria-label="주요 메뉴">
        {MAIN_NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              [
                'rounded-full px-3 py-[7px] text-body-sm',
                isActive
                  ? 'bg-black-500 text-white-50'
                  : 'text-black-100 hover:bg-white-200 hover:text-black-800',
              ].join(' ')
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </header>
  )
}
